import React from 'react';
import { CtaButton } from './ui/CtaButton';
const STUDIO = 'https://cdn.magicpatterns.com/patterns/generated-images/b3a8acf5-cf08-4526-827a-0cb13bdd3241.jpg';
export function FinalCtaSection() {
  return <section className="relative w-full overflow-hidden bg-forestDeep" aria-labelledby="final-heading" data-id="element-32" data-mp="3qt9kcy8plkqx">
      <img src={STUDIO} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-[0.12]" loading="lazy" data-id="element-33" data-mp="3vs43k1al9bbk" />
      <div className="relative mx-auto w-full max-w-2xl px-5 py-12 text-center sm:px-8 sm:py-16" data-id="element-34" data-mp="33505yhdtrz9t">
        <h2 id="final-heading" className="font-serif text-[1.6rem] font-semibold uppercase leading-[1.08] text-ivory sm:text-4xl" data-id="element-35" data-mp="3820auoyxuvzc">
          Your next class doesn’t have to
          <span className="block text-goldSoft" data-id="element-36" data-mp="2fdl04emuaztt">start with a blank page.</span>
        </h2>

        <p className="mt-4 font-serif text-base uppercase tracking-label text-ivory/85 sm:text-xl" data-id="element-37" data-mp="2kcfgzb18yeba">
          Open <span className="text-goldSoft" data-id="element-38" data-mp="2daoxtywvqkvk">•</span> Choose{' '}
          <span className="text-goldSoft" data-id="element-39" data-mp="28d6z11cktm1a">•</span> Teach
        </p>

        <p className="mt-5 font-serif text-[0.68rem] uppercase tracking-label text-ivory/60" data-id="element-40" data-mp="28f06giv0kaac">
          Yoga Teacher System™
        </p>
        <p className="mt-1 font-serif text-4xl font-semibold leading-none text-ivory sm:text-5xl" data-id="element-41" data-mp="1ynnezsd4nm4u">
          $27 <span className="text-base font-normal text-ivory/60" data-id="element-42" data-mp="1um1vho6389lo">USD</span>
        </p>

        <div className="mt-6" data-id="element-43" data-mp="1pmp9f5n1j6k5">
          <CtaButton tone="light" label="Get instant access" microcopy="One-Time Purchase • Instant Access • 7-Day Guarantee" data-id="element-44" data-mp="1ple431dy5qqx" />
        </div>
      </div>
    </section>;
}